import localContent from "../../content.json";

export const languageClient = {
  fetchContentEntry(locale: string, payor: string, key: string) {
    const normalizedLocale = locale === "es-419" ? locale : "en";

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const normalizedPayor = (
      Object.keys(localContent[normalizedLocale]).includes(payor)
        ? payor
        : "default"
    ) as keyof (typeof localContent)[typeof normalizedLocale];

    return (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      localContent[normalizedLocale][normalizedPayor][
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        key as keyof (typeof localContent)[typeof normalizedLocale][typeof normalizedPayor]
      ] ??
      localContent[normalizedLocale].default[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        key as keyof (typeof localContent)[typeof normalizedLocale][typeof normalizedPayor]
      ]
    );
  },
};
